export default __webpack_public_path__ + "static/media/Fambanner.716964c6.png";